import { IFlexibleRemunerationPayRollCycle, IFlexibleRemunerationPayRollCycles } from '../../interfaces/company';
import { capitalize, getLocalizedMonthName } from '../utils';

export interface IRemainingCycleMonth {
  name: string;
  displayName: string;
  index: number;
  year: number;
}

export interface IGetRemainingCyclesParams {
  companyRFCycles?: IFlexibleRemunerationPayRollCycles | null;
  companyLocale?: string | null;
  modelType?: string;
  referenceDate?: Date;
}

const getPayrollMonthName = (year: number, monthIndex: number, companyLocale?: string | null): string => {
  const date = new Date(year, monthIndex, 1);
  const rawName = date.toLocaleString(companyLocale || 'en-US', { month: 'long' }).replace('.', '');
  return capitalize(rawName);
};

export const getRemainingCycles = ({
  companyRFCycles,
  companyLocale,
  modelType,
  referenceDate = new Date()
}: IGetRemainingCyclesParams): IRemainingCycleMonth[] => {
  const openCycle = companyRFCycles?.payRollCycles?.find((c) => c.status === 'OPEN');
  if (!openCycle) return [];

  let monthOffset = 0;
  if (modelType === 'forecast') {
    const [endYear, endMonth, endDayOfMonth] = (openCycle.endDay || '').split('-').map(Number);
    const cycleEndDate = new Date(endYear, endMonth - 1, endDayOfMonth, 23, 59, 59, 999);
    monthOffset = Number.isNaN(cycleEndDate.getTime()) || referenceDate <= cycleEndDate ? 1 : 2;
  }

  // Forecast shows one month less than what is sent to the service: `name`/`index`/`year`
  // keep the real payroll month for the payload, `displayName` is the label for the user.
  const displayOffset = modelType === 'forecast' ? 1 : 0;

  const months: IRemainingCycleMonth[] = [];
  for (let m = openCycle.cycleMonth - 1 + monthOffset; m < 12; m++) {
    months.push({
      name: getPayrollMonthName(openCycle.cycleYear, m, companyLocale),
      displayName: getPayrollMonthName(openCycle.cycleYear, m - displayOffset, companyLocale),
      index: m + 1,
      year: openCycle.cycleYear
    });
  }
  return months;
};

export const getCycleLabel = (cycle?: IFlexibleRemunerationPayRollCycle | null): string =>
  cycle ? capitalize(`${getLocalizedMonthName(cycle.cycleMonth)} ${cycle.cycleYear}`) : '';
